import React, { useState } from "react";
import "./StickyNavbar.css";

const StickyNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="logo">
          <img src="/assets/Logo10.png" alt="Logo" className="logo-img" />
        </div>

        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          <li>
            <a href="#home" onClick={toggleMenu} class="nav-link">
              Home
            </a>
          </li>
          <li>
            <a href="#Services" onClick={toggleMenu}  class="nav-link">
                Services
            </a>
          </li>
          <li>
            <a href="#How-it-works" onClick={toggleMenu}  class="nav-link">
              How it Works
            </a>
          </li>
          <li>
            <a href="#Pricing" onClick={toggleMenu}  class="nav-link">
              Pricing
            </a>
          </li>
           <li>
            <a href="#FAQs" onClick={toggleMenu}  class="nav-link">
              FAQs
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default StickyNavbar;
